import PropTypes from 'prop-types';

import { PulseIndicator } from 'basic-components';

import classNames from 'classnames';
import './BotIsTyping.scss';

const BotIsTyping = ({ isTyping }) => (
  <div
      className={classNames(
        "ng-python-editor__chat__content__chat__typing",
        { "ng-python-editor__chat__content__chat__typing--is-typing": isTyping }
      )}
  >
    <p className="ng-python-editor__chat__content__chat__typing__text">Assistant is generating code</p>
    <PulseIndicator
        loading
        size={6}
    />
  </div>
)

BotIsTyping.propTypes = {
  isTyping: PropTypes.bool.isRequired
}

export default BotIsTyping;
